import getMetricEventsRaw from '../../../services/ruutsApi/getMetricEvents'
import type { MetricEvent } from '../../../types/apiModels'

// getMetricEvents is plain JS: `unwrapCollection` widens to `unknown[]` there, so pin it here.
export const getMetricEvents = getMetricEventsRaw as unknown as (args: {
  farmId: string
  namespace: string
  year: string
}) => Promise<MetricEvent[] | null>
